import React from 'react';
import './App.css';
//import Home from './components/Home/Home';
import Navbar from './components/Navbar';
//const axios=require('axios')
function App() {


  return (
    <div className="App">
     <Navbar/>
    </div>
  );
}



export default App;
